import { render, staticRenderFns } from "./SimpleSecretSelector.vue?vue&type=template&id=17844852&"
import script from "./SimpleSecretSelector.vue?vue&type=script&lang=js&"
export * from "./SimpleSecretSelector.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSecretSelector.vue?vue&type=style&index=0&id=17844852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports